// src/main.mock.ts
//
// Development entry point — uses mocked API data via MockInterceptor.
// The standard src/main.ts is untouched and always uses the real app.config.ts.
//
// HOW TO USE
// ─────────────────────────────────────────────────────────────────────────────
// Option A — Angular CLI (recommended):
//   Add a "mock" build configuration to angular.json (see note below),
//   then run:  ng serve --configuration=mock
//
// Option B — quick alias in package.json:
//   "scripts": {
//     "start:mock": "ng serve --main src/main.mock.ts"
//   }
//   then run:  npm run start:mock
//
// PRODUCTION SAFETY
// ─────────────────────────────────────────────────────────────────────────────
// `ng build` (without --configuration=mock) uses main.ts → app.config.ts.
// MockInterceptor and all fixture files are excluded from the production bundle.

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { appMockConfig } from './app.config.mock';

bootstrapApplication(AppComponent, appMockConfig)
    .catch((err) => console.error(err));
